export default "__VITE_ASSET__BSLmyo7b__"